import { Box, Typography } from "@material-ui/core";
import { useAppSelector } from "../../../store/hooks";
import { SchemeData } from "../cart/CartItems";
import CustomButton from "../../forms/CustomButton";
import { TableActionProps, useTableAction } from "./TableAction/useTableAction";
import { convertDateToIndian, convertToInr } from "../../../utils/cart";

export default function DashboardTableResponsive({
  isPending,
}: {
  isPending: boolean;
}) {
  const { transactionHistory } = useTable();
  return (
    <Box>
      {transactionHistory.map((item, index) => {
        const { orders } = item;
        const {
          dco_inv_name = "NA",
          dco_inv_mobile = "NA",
          investment_type = "-",
          dco_updated_at = "-",
        } = orders[0];
        return (
          <Box
            sx={{
              m: "1rem 0.5rem",
              p: "0.5rem 1rem",
              border: "1px solid rgba(211,211,211,1)",
              boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            }}
            key={index}
          >
            <Typography
              align="center"
              variant="overline"
              style={{
                fontSize: "1rem",
              }}
            >
              {investment_type}
            </Typography>
            <SchemeData name="Investor Name" value={dco_inv_name} />
            <SchemeData name="Mobile" value={dco_inv_mobile} />
            <SchemeData
              name="Transaction Date"
              value={convertDateToIndian(dco_updated_at)}
            />
            {orders.map((order, orderIndex) => (
              <Box>
                <Box
                  sx={{
                    p: "1rem",
                    border: "1px solid rgba(211,211,211,0.3)",
                  }}
                  key={orderIndex}
                >
                  <Typography style={{ marginBottom: "0.5rem" }}>
                    {order.scheme}
                  </Typography>
                  <SchemeData name="Reference Number" value={order.dco_ihno} />
                  <SchemeData
                    name="AMOUNT/ UNITS"
                    value={
                      order.units
                        ? `U-${order.units}`
                        : order.amount
                        ? convertToInr(order.amount)
                        : "-"
                    }
                  />
                  {order.sipamount ? (
                    <SchemeData
                      name="SIP Amount"
                      value={convertToInr(order.sipamount)}
                    />
                  ) : null}
                </Box>
                <Box display="flex" justifyContent="center">
                  <TableAction
                    isCart={Boolean(orders.length > 1 || item.dco_cart_id)}
                    isDotNet={item.isDotNet}
                    isPending={isPending}
                    item={item}
                    length={orders.length}
                    order={order}
                    orderIndex={orderIndex}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        );
      })}
    </Box>
  );
}

function useTable() {
  const { transactionHistory } = useAppSelector((state) => state.cartReducer);
  return {
    transactionHistory,
  };
}

function TableAction(props: React.ComponentProps<TableActionProps>) {
  const { actionLabel, tableAction } = useTableAction({
    isCart: props.isCart,
    isDotNet: props.isDotNet,
    isPending: props.isPending,
    item: props.item,
    length: props.length,
    order: props.order,
    orderIndex: props.orderIndex,
  });

  if (actionLabel === "NA") {
    return null;
  }

  if (props.orderIndex !== props.length - 1) {
    return null;
  }

  return <CustomButton label={actionLabel} onClick={tableAction} />;
}
